import {StaticTageaImage} from "@web-libs/ui/ui-components/media/static-tagea-image";
import RegisterIllustrationImage from "@web-public/register-illustration.png";

export const RegisterIllustration = () => {
    return (
        <StaticTageaImage style={{maxHeight:"700px"}} responsive alt="Frau ist an ihrem Laptop." src={RegisterIllustrationImage}/>
    )
}
